/** Turns the quote number in a Generate confirmation ("Created quote QCB-…")
 *  into a markdown link to the new quote, so the line in the thread is a way
 *  to reach the quote rather than only a record that it exists (OMNI-1218).
 *  Returns the message unchanged when the result lacks the quote id, number
 *  or product, or the message does not mention the quote. */
export function linkQuoteInMessage(
  message: string | undefined,
  data: Record<string, unknown> | null | undefined,
  buildPath: (quoteId: string, product: string) => string
): string | undefined {
  const quoteId = typeof data?.newQuoteId === 'string' ? data.newQuoteId : '';
  const quoteNumber =
    typeof data?.newQuoteNumber === 'string' ? data.newQuoteNumber : '';
  const product = typeof data?.product === 'string' ? data.product : '';
  if (
    !message ||
    !quoteId ||
    !quoteNumber ||
    !product ||
    !message.includes(quoteNumber)
  ) {
    return message;
  }
  return message.replace(
    quoteNumber,
    `[${quoteNumber}](${buildPath(quoteId, product)})`
  );
}
